/**
 * CancelIcon — A cross: close, remove or cancel. Hugeicons cancel-01 (MIT).
 */

import svg from './svg/cancel.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const CancelIcon = makeSvgIcon('cancel', svg);
